import { render, staticRenderFns } from "./ProductInquiry.vue?vue&type=template&id=3bf76e4a&"
import script from "./ProductInquiry.vue?vue&type=script&lang=ts&"
export * from "./ProductInquiry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports